import { KpiKeys } from '@models';

/**
 * Custom chart titles for trend charts, mapped by KPI key.
 * Trend charts use the KPI key for lookup since all trend charts share the same id ('trendChart').
 */
const KPI_TREND_CHART_CUSTOM_TITLES: Partial<Record<KpiKeys, string>> = {
  enrolled: 'Subject enrolled over time',
  active: 'Site activation over time'
};

export { KPI_TREND_CHART_CUSTOM_TITLES };
